const SHADOWS = {
  button: "5px 5px 30px 0px rgba(0, 0, 0, 0.20)",
  modal: "0px 4px 77px 0px rgba(0, 0, 0, 0.10)",
  card: "0px 2px 8px 0px rgba(0, 0, 0, 0.10), 0px 8px 20px 0px rgba(0, 0, 0, 0.10)",
  range: "0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15)",
};

export default SHADOWS;
